import { render, staticRenderFns } from "./cardSides.vue?vue&type=template&id=6ddd3484&scoped=true"
import script from "./cardSides.vue?vue&type=script&lang=js"
export * from "./cardSides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddd3484",
  null
  
)

export default component.exports